// Fechas del backend. MySQL guarda y devuelve los TIMESTAMP en UTC (zona del
// VPS) y en formato "YYYY-MM-DD HH:MM:SS", sin zona. `new Date()` interpreta
// ese formato como hora LOCAL del navegador, y en Madrid eso adelanta dos horas
// la antigüedad ("hace 2 horas" para un comentario de hace 2 minutos). Aquí se
// leen como UTC; si ya traen zona (Z, +02:00) o son solo fecha, se respetan.
const NAIVE_DATETIME = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;

export function parseServerDate(value) {
  if (value == null || value === '') return new Date(NaN);
  if (value instanceof Date) return value;
  const s = String(value).trim();
  if (NAIVE_DATETIME.test(s)) return new Date(`${s.replace(' ', 'T')}Z`);
  return new Date(s);
}
